import React from "react";
import { BallTriangle } from "react-loading-icons";

function Loading() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ width: "100%", height: "100vh" }}
    >
      <BallTriangle stroke="#000000" strokeOpacity={1} speed={0.75} />;
    </div>
  );
}

export default Loading;
